module.exports = __webpack_public_path__ + "static/media/goodnest_job2.0fba72da.jpg";